// removed by extract-text-webpack-plugin
module.exports = {"page":"_2bw8","detailsSection":"_2M24","formSection":"_1mv3","bossCard":"sGCg"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Settings/Settings.scss
// module id = Lxp/
// module chunks = 0